import type { BuildContext, Fragment, FormatId } from "../types.js";
import { mergeFragments } from "../types.js";
import { buildCompositionHtml } from "../composition.js";

export function formatTag(f: FormatId): string {
  return f === "9:16" ? "vertical" : f === "1:1" ? "square" : "landscape";
}

export type AssemblyArgs = {
  templateId: string;
  ctx: BuildContext;
  /** Background fragment (BackgroundGradient or BrandBackdrop). */
  background: Fragment;
  /** Inner content fragments — their `html` is inlined into the SafeArea. */
  contentFragments: Fragment[];
  /** Pre-assembled HTML to inline inside `#stage > .safe-area`. */
  safeAreaInnerHtml: string;
  /** Pre-assembled SafeArea fragment (only its html will be inlined, but
   *  css/init/tweens are merged). */
  safeArea: Fragment;
};

/**
 * Assemble a complete HTML document. Inlines:
 *   #stage > background.html
 *   #stage > safeArea.html (which already contains safeAreaInnerHtml)
 * and merges all CSS / init / tweens.
 */
export function assemble(args: AssemblyArgs): string {
  const { ctx, templateId, background, contentFragments, safeArea } = args;
  const merged = mergeFragments([background, ...contentFragments, safeArea]);

  const stageHtml = background.html + "\n" + safeArea.html;

  return buildCompositionHtml({
    compositionId: `${templateId}-${formatTag(ctx.format)}-${ctx.locale}`,
    title: templateId,
    ctx,
    fragments: [
      { html: "", css: merged.css, init: merged.init, tweens: merged.tweens },
      { html: stageHtml },
    ],
  });
}
